import { Injectable } from '@angular/core'
import { Observable } from 'rxjs/Rx'

import { ModelFactory } from './model-repository/model-factory'
import { MenuItem } from '@mprep/shared/data/models'

@Injectable()
export class MenuItemServiceMock {

  public findAllModels(inlcudes): Observable<MenuItem[]> {
    return Observable.of([
      <MenuItem> ModelFactory.createAndInitialize(MenuItem.name, {id: 1, title: 'MenuItem 1', resourceId: 1}),
      <MenuItem> ModelFactory.createAndInitialize(MenuItem.name, {id: 2, title: 'MenuItem 2', resourceId: 2,
        menuItems: [
          <MenuItem> ModelFactory.createAndInitialize(MenuItem.name, {id: 11, title: 'MenuItem 11', resourceId: 11}),
          <MenuItem> ModelFactory.createAndInitialize(MenuItem.name, {id: 12, title: 'MenuItem 12', resourceId: 12}),
          <MenuItem> ModelFactory.createAndInitialize(MenuItem.name, {id: 13, title: 'MenuItem 13', resourceId: 13}),
        ]
      }),
      <MenuItem> ModelFactory.createAndInitialize(MenuItem.name, {id: 3, title: 'MenuItem 3', resourceId: 3}),
    ])
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/menu-item.service.mock.ts